import React from 'react';
import { string, oneOf, func } from 'prop-types';
import classnames from 'classnames';
import { Icons } from 'components';
import './CaretButton.scss';

export const ORIENTATION = {
    RIGHT: 'right',
    LEFT: 'left',
};

export default function CaretButton({ className, orientation, onClick }) {
    const rootClassnames = classnames('caret-button', className);

    const handleClick = event => {
        if (onClick) onClick(event, orientation);
    };

    const harfCircleClassnames = classnames('caret-button__half-circle', {
        'caret-button__half-circle--left': orientation === ORIENTATION.LEFT,
        'caret-button__half-circle--right': orientation === ORIENTATION.RIGHT,
    });

    return (
        <button className={rootClassnames} onClick={handleClick}>
            <div className={harfCircleClassnames}>
                {orientation === ORIENTATION.LEFT ? (
                    <Icons.ChevronLeft className="caret-button__half-circle__icon" />
                ) : (
                    <Icons.ChevronRight className="caret-button__half-circle__icon" />
                )}
            </div>
        </button>
    );
}

CaretButton.propTypes = {
    className: string,
    orientation: oneOf([ORIENTATION.LEFT, ORIENTATION.RIGHT]).isRequired,
    onClick: func,
};

CaretButton.defaultProps = {
    className: null,
    onClick: null,
};
